<div id="section-alerts" class="container m-t-40">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Alerts</p>

    <alert [alert]="alertPrimary"></alert>
    <alert [alert]="alertSuccess"></alert>
    <alert [alert]="alertDanger"></alert>
    <alert [alert]="alertWarning"></alert>
    <alert [alert]="alertInfo"></alert>
  </div>
</div>
